import o from "./index444.js";
import { createElementBlock as t, openBlock as n, createElementVNode as s, renderSlot as c } from "vue";
/* empty css         */
import r from "./index231.js";
const a = ["data-component"], p = { class: "block w-16 h-16" };
function d(e, i, m, _, l, f) {
  return n(), t("span", {
    class: "ms-interactiveIcons",
    "data-component": e.$options.name
  }, [
    s("span", p, [
      c(e.$slots, "default", {}, void 0, !0)
    ])
  ], 8, a);
}
const k = /* @__PURE__ */ r(o, [["render", d], ["__scopeId", "data-v-5e795c64"]]);
export {
  k as default
};
